/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-07-11 11:22:43
 *
 *******************************************************/
// @flow

import { getJSON } from 'redux-api-middleware';
import { I18n } from '@shopify/react-i18n';
import { processRes } from 'src/helpers/actions-helper';
import { getShop } from 'src/helpers';

import apiService from 'src/services/api-service';
import {
  GET_NOTIFICATIONS_REQUEST,
  GET_NOTIFICATIONS_SUCCESS,
  GET_NOTIFICATIONS_FAILURE,
  DISMISS_NOTIFICATION_REQUEST
} from 'stores/flow-type/dashboard/notification.type';

/**
 * call to admin dashboard block api
 * @return {object} The RSAA object for API middleware
 */
export const getNotifications = (i18n: I18n) => {
  return apiService.sendRequest(
    'admin-v3.dashboard-notifications.get-dashboard-notifications',
    {},
    [
      GET_NOTIFICATIONS_REQUEST,
      {
        type: GET_NOTIFICATIONS_SUCCESS,
        payload: async (action, state, res) => {
          const data = await getJSON(res);
          return { data };
        }
      },
      {
        type: GET_NOTIFICATIONS_FAILURE,
        payload: async (action, state, res) =>
          await processRes(
            res,
            'error',
            i18n.translate('AdminHTML.Dashboard.Actions.getNotifications'),
            i18n
          )
      }
    ]
  );
};

/**
 * Dismiss notification
 *
 * @param  {[type]} notificationId: number
 */
export const dismissNotification = (notificationId: number) => ({
  type: DISMISS_NOTIFICATION_REQUEST,
  payload: { notificationId, shop: getShop() }
});
